import { render, staticRenderFns } from "./Complain.vue?vue&type=template&id=330ba9b7&scoped=true&"
import script from "./Complain.vue?vue&type=script&lang=js&"
export * from "./Complain.vue?vue&type=script&lang=js&"
import style0 from "./Complain.vue?vue&type=style&index=0&id=330ba9b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ba9b7",
  null
  
)

export default component.exports